import { useContext, useState } from 'react';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';
import useRaCostSetting from '../../../settings/hooks/useRaCostSetting';
import moment from 'moment';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { ResourceAllocationFiltersContext } from '../../../../state/filters/contexts';
import useResourceAllocationService from 'common/services/resource-allocation.service.versions';

const useExport = ({ resourceType, keyword, tableSortBy }) => {
  const {
    state: { period, filtersPayload, extraPayload }
  } = useContext(ResourceAllocationFiltersContext);
  const raService = useResourceAllocationService();

  const raCost = useRaCostSetting();
  const pmSensorAuthId = usePmSensorAuthId();
  const [isLoading, setIsLoading] = useState(false);

  const downloadCSV = (data, filename) => {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const generateFilename = () =>
    `resource_allocation_data_${resourceType.name}_${moment().format(
      'YYYY-MM-DDTHH-mm-ss'
    )}`;

  const amplitudeTracking = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.RESOURCE_ALLOCATION,
      click_type: TRACKING.CLICK.RESOURCE_ALLOCATION.AGGREGATED_TABLE.EXPORT_CSV
    });
  };
  const exportToCSV = async () => {
    try {
      amplitudeTracking();
      setIsLoading(true);
      const res = await raService.exportAggregatedTable({
        sensor_authorization_id: pmSensorAuthId,
        before: period.before,
        after: period.after,
        type: resourceType.type,
        issue_type: resourceType.issueType,
        keyword,
        sort_by: tableSortBy.key,
        sort_dir: tableSortBy.dir,
        ...(resourceType.extraParams && {
          extraParams: resourceType.extraParams
        }),
        filtersPayload,
        ...(raCost?.value && {
          annual_cost: raCost.value
        }),
        extraPayload
      });
      const filename = generateFilename();
      downloadCSV(res, filename);
    } catch (e) {
      window.TrackJS &&
        window.TrackJS.console.error(
          'Failed on downloading resource-allocation CSV file',
          e
        );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    exportToCSV
  };
};

export default useExport;
